import React, { useState } from "react";
import styles from "./FeeRemainder.module.css";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import FeeRemainderEmail from "../../components/FeeRemainderEmail/FeeRemainderEmail";
import CalendarInput from "../../components/CalendarInput/CalendarInput";
import IconAndName from "../../components/IconAndName/IconAndName";
import { IoAddCircleOutline } from "react-icons/io5";
import { FiMail } from "react-icons/fi";

const FeeRemainder = () => {
    const dispatch = useDispatch();
  const [emails, setEmails] = useState([
    {
      id: 1,
      message:
        "Dear Parents,\nPlease pay your ward fee on or before 06/06/2025 i.e monday to avoid late fee.\nRs.500 is chargeable is its late.",
      subject: "Regarding First Term Fee every parent must pay",
      to: ["1@gmail.com", "2@gmail.com"],
      time: "12:00 PM",
      date: "3rd June 2025",
      days: 1,
    },
    {
      id: 2,
      message:
        "Dear Parents,\nPlease pay your ward fee on or before 06/06/2025 i.e monday to avoid late fee.\nRs.500 is chargeable is its late.",
      subject: "Regarding First Term Fee every parent must pay",
      to: ["1@gmail.com", "2@gmail.com"],
      time: "12:00 PM",
      date: "3rd June 2025",
      days: 1,
    },
    {
      id: 3,
      message:
        "Dear Parents,\nPlease pay your ward fee on or before 06/06/2025 i.e monday to avoid late fee.\nRs.500 is chargeable is its late.",
      subject: "Regarding First Term Fee every parent must pay",
      to: ["1@gmail.com", "2@gmail.com"],
      time: "12:00 PM",
      date: "3rd June 2025",
      days: 1,
    },
    {
      id: 4,
      message:
        "Dear Parents,\nPlease pay your ward fee on or before 06/06/2025 i.e monday to avoid late fee.\nRs.500 is chargeable is its late.",
      subject: "Regarding First Term Fee every parent must pay",
      to: ["1@gmail.com", "2@gmail.com"],
      time: "12:00 PM",
      date: "3rd June 2025",
      days: 1,
    },
  ]);
  const [selectedDate, setSelectedDate] = useState("");
  const handleAddClick = () => dispatch(openModal("addRegister"));
  const handleEmailRemove = (emailId, addressToRemove) => {
    setEmails((prev) =>
      prev.map((email) =>
        email.id === emailId
          ? { ...email, to: email.to.filter((t) => t !== addressToRemove) }
          : email
      )
    );
  };

  const handleActionSelect = (action) => {
    console.log("Selected action:", action);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.toolbarWrapper}>
          <IconAndName
            icon={<FiMail size={16} />}
            title="Add Email"
            onClick={handleAddClick}
            bgColor="Primary_Color"
          />
          <CalendarInput
            label="Date"
            value={selectedDate}
            onChange={setSelectedDate}
            background="var(--Utility_Color1)"
            textColor="gray"
            iconColor="gray"
            placeholderColor="gray"
            borderRadius="25px"
            shadow={false}
          />
        </div>
        <div className={styles.pageWrapper}>
          <div className={styles.grid}>
            {emails.map((item) => (
              <FeeRemainderEmail
                key={item.id}
                id={item.id}
                message={item.message}
                subject={item.subject}
                to={item.to}
                time={item.time}
                date={item.date}
                sendIn={`${item.days} ${item.days > 1 ? "Days" : "Day"}`}
                onActionSelect={handleActionSelect}
                onRemoveRecipient={handleEmailRemove}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeeRemainder;
